module.exports = __webpack_public_path__ + "2b855f06dc8b2ab6d1cceb0dd37095cc.pdf";